import React from "react";

const mapOutboundRefs = (ref) => {
    // console.log("--------------------- outbound ref");
    // console.log(ref);
    return (
    ref.fields?.srcType === "garden"
    ? {
        mdx: ref.body,
        title: ref.fields.title,
        id: ref.fields.id,
        displayTitle: ref.fields.title,
        slug: ref.fields.slug,
        aliases: [],
      }
    : null // console.warn(`Cannot map outbound ref`, ref) || null
    )
  }

const mapInboundRefs = (ref) => {
  // console.log(ref);
  return (
   ref.fields?.srcType === "garden"
    ? {
      mdx: ref.body,
      title: ref.fields.title,
      id: ref.fields.id,
      displayTitle: ref.fields.title,
      slug: ref.fields.slug,
      aliases: [],
    }
    : null // console.warn(`Cannot map inbound ref`, ref) || null
  )
}

export const dataToNote = (data) => {
  console.log(`processing node: ${data.file.id} - ${data.file.childMdx.fields.title}`);

  return data.file
    ? {
        title: data.file.childMdx.fields.title,
        slug: data.file.childMdx.fields.slug,
        mdx: data.file.childMdx.body,
        outboundReferences: data.file.childMdx.outboundReferences
          .map(mapOutboundRefs)
          .filter((x) => !!x),
        inboundReferences: data.file.childMdx.inboundReferences
          .map(mapInboundRefs)
          .filter((x) => !!x),
      }
    : null;
}

export const dataToSlug = (data) => {
  return (
    data.file
      ? `${data.file.childMdx.fields.slug}`
      : null
  )
}
